import request from '../utils/request';

/**
 * 获取用户资料分页列表
 * @param {Object} params - 查询参数
 * @returns {Promise} - 返回请求结果
 */
export function getUserProfileList(params) {
  return request({
    url: '/user-profiles/list',
    method: 'get',
    params
  });
} 